/* eslint-disable complexity */
import React, {useState} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import ServiceHistoryRevampModal from "../service-history-revamp-modal/component";
import CheckIcon from "./images/right.svg";
import DownloadIcon from "./images/download.svg";
import ShieldIcon from "./images/security.svg";
import FreeSticker from "./images/free.png";

const ServiceHistoryRevamp = ({config, content = {}}) => {
    const {serviceHistory = [], carHistory = {}, oldTimer = false} = content || {};
    const {ppsrReportLink = ""} = content;
    const [showModal, setShowModal] = useState(false);
    const openReport = () => {
        window.open(ppsrReportLink);
    };
    const showModalHandler = () => {
        setShowModal(!showModal);
    };
    const isServiceHistoryAvailable = (serviceHistory || []).length;
    const recentServiceSubHeading = isServiceHistoryAvailable ? "The car is ready and serviced for next 10,000kms" : "The service record of this vehicle is getting uploaded and will be updated here soon.You can download the PPSR report below";
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.leftWrapper"}>
                <h3 styleName={"styles.featureHeading"}>Car history</h3>
                <p styleName={"styles.subHeading"}>Here is the service history for this vehicle. In cases where no additional service records are available, the details provided will focus on the service carried out by CARS24, ensuring you have the most relevant information regarding the vehicle's maintenance.</p>
                {oldTimer && <div styleName={"styles.stickerWrapper"}>
                    <img src={FreeSticker} alt="Free 12-Months CARS24 Platinum Cover free sticker" />
                    <div className="media" styleName={"styles.mediaWrapper"}>
                        <img src={ShieldIcon} alt="Free 12-Months CARS24 Platinum Cover" />
                        <div className="media-body">
                            <p styleName={"styles.freeCover"}>Free 12-Months CARS24<br />Platinum Cover</p>
                        </div>
                    </div>
                </div>}
            </div>
            <div styleName={"styles.rightSectionWrap"}>
                <div styleName={`styles.carHistorySteps ${isServiceHistoryAvailable ? "styles.carHistoryStepsHeight" : ""}`}>
                    <h3 styleName={"styles.carHistoryHeading"}>Car history</h3>
                    <ul styleName={`styles.carHistoryListWrapper ${isServiceHistoryAvailable ? "styles.carHistoryWithButton" : "styles.carHistoryWithoutButton"}`}>
                        {(carHistory?.values || []).map((history) => <li><img src={CheckIcon} alt="Verified steps for car history" /><div>{history.value}</div></li>
                        )}

                    </ul>
                    {isServiceHistoryAvailable ? <button onClick={openReport}>PPSR Report<img src={DownloadIcon} alt="Download PPSR report for car history" /></button> : <></>}
                </div>
                <div styleName={`styles.recentServiceWrapper ${isServiceHistoryAvailable ? "styles.recentServiceWrapperHeight" : ""}`}>
                    <h3 styleName={"styles.recentServiceHeading"}>Recent services</h3>
                    <p styleName={"styles.recentServiceSubHeading"}>{recentServiceSubHeading}</p>
                    {/* timeline */}
                    <div styleName={"styles.contentWrapper"}>
                        {(serviceHistory || []).map(({serviceDate, postService = {}, serviceCenterAddress}, index) =>
                            (
                                <div key={index} styleName={"styles.recentServiceSectionWrap"}>
                                    <div styleName={"styles.dateWrapper"}>
                                        <p styleName={"styles.serviceDate"}>{serviceDate}</p>
                                        {postService.odo && <p styleName={"styles.kmWrapper"}>{postService.odo} Km</p>}
                                    </div>
                                    <p styleName={"styles.serviceCenterAddress"}>{serviceCenterAddress}</p>
                                </div>
                            )
                        )}
                    </div>
                    {isServiceHistoryAvailable ?
                        <button styleName="styles.ServiceHistoryLogButton" onClick={showModalHandler}>View service history and log book</button> :
                        <button styleName="styles.ppsrReportButton" onClick={openReport}>PPSR Report<img src={DownloadIcon} alt="Download PPSR report for car history" /></button>}
                </div>
            </div>
            {showModal && <ServiceHistoryRevampModal config={config} onClose={showModalHandler} content={content} />}
        </div>
    );
};

ServiceHistoryRevamp.propTypes = {
    config: PropTypes.object,
    content: PropTypes.object,
    carhistoryRef: PropTypes.object
};

export default ServiceHistoryRevamp;
